<template>
    <div id="statement_content">
        <div class="content">
            <p v-for="(paragraph, index) in paragraphs" :key="index">{{paragraph}}</p>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        paragraphs : {
            type : Array
        }
    }
}
</script>

<style lang="scss">
    #statement_content{
        display: flex;
        padding: 0 25px;
        height: 70vh;

        p{
            padding: 5% 0;
            font-size: 11pt;
            line-height: 20px;

        }
    }

    @media screen and (max-width: 400px){
        #statement_content{
            overflow-y: scroll;
        }
    }
</style>